export default __webpack_public_path__ + "static/media/ret_sta_1.6107d2ee.jpeg";